import {determineLanguage} from "./util";
import {language} from "../enum/language";

export enum traductionEnum {
    START_BY,
    ENDS_BY,
    BTN_COUPON_ADDED,
    BTN_COUPON_EXCLUSIVE,
    BTN_COUPON_BURNED,
    BTN_COUPON_ADD,
    BTN_COUPON_UNCLIP,
    ERROR_MSG_GENERIC,
    ERROR_MSG_FORMAT_GENERIC,
    ERROR_MSG_INVALID_GENERIC,
    ERROR_CARD_NUMBER,
    POSTAL_CODE_FORMAT_ERROR,
    ADDRESS_LINE1_REQUIRED,
    PROVINCE_REQUIRED,
    PHONE_TYPE_REQUIRED,
    CITY_REQUIRED,
    BIRTH_YEAR_REQUIRED,
    BIRTH_YEAR_LESS_THAN_1890,
    NOT_OLD_ENOUGH,
    PHONE_NUMBER_REQUIRED,
    POSTAL_CODE_REQUIRED,
    PROVINCE_PLACEHOLDER,
    PHONE_TYPE_PLACEHOLDER,
    SEE_MORE_COUPON_BUTTON_CLICKED,
    SEE_MORE_QUESTION_BUTTON_CLICKED,
    SEE_MORE_BUTTON_GENERIC_CLICKED,
    BTN_COUPON_AVAILABLE_SOON,
    OPEN_NEW_WINDOWS,
    CLOSE,
}

export const TRADUCTIONS =
    {
        START_BY: {fr: '<strong>Débute : </strong>', en: '<strong>Starts : </strong>'},
        ENDS_BY: {fr: '<strong>Prend fin : </strong>', en: '<strong>Expires : </strong>'},
        BTN_COUPON_ADDED: {fr: 'Coupon ajouté', en: 'Coupon added'},
        BTN_COUPON_EXCLUSIVE: {fr: 'exclusif à l\'appli', en: 'app-exclusive coupon'},
        BTN_COUPON_BURNED: {fr: 'Coupon utilisé', en: 'Burned coupon'},
        BTN_COUPON_ADD: {fr: 'J\'ajoute mon coupon', en: 'Add my coupon'},
        BTN_COUPON_UNCLIP: {fr: 'Je retire mon coupon', en: 'Remove my coupon'},
        ERROR_MSG_FORMAT_GENERIC: {fr: 'Erreur de format. Merci de vérifier et réessayer.', en: 'Formatting error. Please try again.'},
        ERROR_MSG_INVALID_GENERIC: {fr: 'Invalide. Merci de vérifier et réessayer.', en: 'Invalid. Please try again.'},
        ERROR_MSG_GENERIC: {fr: 'Une erreur est survenue', en: 'An error has occurred'},
        ERROR_CARD_NUMBER: {fr: 'Le numéro de la carte semble erroné. Réessayez ou contactez Moi.', en: 'There seems to be a problem with your card number. Please try again or contact Moi.'},
        POSTAL_CODE_FORMAT_ERROR: {fr: 'Code postal incorrect. Format accepté : A1A 1A1', en: 'Invalid postal code. Accepted format: A1A 1A1'},
        ADDRESS_LINE1_REQUIRED: {fr: 'Mon adresse est requise', en: 'My address is required'},
        PROVINCE_REQUIRED: {fr: 'Ma province est requise', en: 'My province is required'},
        PHONE_TYPE_REQUIRED: {fr: 'Requis', en: 'Required'},
        CITY_REQUIRED: {fr: 'Ma ville est requise', en: 'My city is required'},
        BIRTH_YEAR_REQUIRED: {
            fr: 'Date de naissance obligatoire pour valider les offres ciblées pouvant vous être envoyées selon les lois applicables',
            en: 'Birth date required to validate personalized offers that may be sent to you according to applicable laws'
        },
        BIRTH_YEAR_LESS_THAN_1890: {fr: 'Vous devez être né au plus tôt en 1890 pour adhérer au programme.', en: 'You must be born no earlier than 1890 to join the program.'},
        NOT_OLD_ENOUGH: {fr: 'Vous devez être âgé de 16 ans et plus pour adhérer au programme.', en: 'Invalid. You must be 16 years of age or older to enroll in the Moi program.'},
        PHONE_NUMBER_REQUIRED: {fr: 'Mon numéro de téléphone est requis', en: 'My phone number is required'},
        POSTAL_CODE_REQUIRED: {fr: 'Mon code postal est requis', en: 'My postal code is required'},
        PROVINCE_PLACEHOLDER: {fr: 'Ma province', en: 'My province'},
        PHONE_TYPE_PLACEHOLDER: {fr: 'Type', en: 'Type'},
        SEE_MORE_COUPON_BUTTON_CLICKED: {fr: 'voir tous les coupons', en: 'see all coupons'},
        SEE_MORE_QUESTION_BUTTON_CLICKED: {fr: 'Voir toutes les questions', en: 'See all questions'},
        SEE_MORE_BUTTON_GENERIC_CLICKED: {fr: 'Voir tout', en: 'See all'},
        BTN_COUPON_AVAILABLE_SOON: {fr: 'Bientôt', en: 'Soon'},
        OPEN_NEW_WINDOWS: {fr: 'Ce lien externe ouvre une nouvelle fenêtre', en: 'This link opens a new window'},
        CLOSE: {fr: 'Fermer', en: 'Close'}
    }

export const getTraduction = (traduction: traductionEnum): any => {
    let result;
    let isLangFrench = determineLanguage() === language.french;

    Object.entries(TRADUCTIONS).map(([enumName, values]) => {
        if (enumName.toString() === traductionEnum[traduction]) {
            result = isLangFrench ? values.fr : values.en;
        }
    });
    return result;
}